module.exports = __webpack_public_path__ + "img/instagram.af620fc9.svg";